import React from "react"

import { Input as DefaultInput, ErrorMessageProps } from "../../Input"
import { NumberInputContext } from "../NumberInput"

export const NumberInputErrorMessage = React.memo(
  ({ children, ...props }: ErrorMessageProps<Record<string, number>>) => {
    const { min, max } = React.useContext(NumberInputContext)

    return <DefaultInput.ErrorMessage {...props} context={{ min, max }} />
  }
)
